import { Menu } from "antd/es";
import { Guid } from "guid-typescript";
import _ from "lodash";
import { PureComponent, ReactNode } from "react";
import withCommonEvents from "../../../shared/hoc/with-common-events";
import { CommonProps } from "../common/common-props";
import { Icon, IconLibrary, IconType } from "../icon/icon";

interface MenuItemProps {
  icon?: string;
  iconLibrary?: IconLibrary;
  iconType?: IconType;
}

interface MenuItemState {}

class MenuItem extends PureComponent<MenuItemProps & CommonProps, MenuItemState> {
  constructor(props: MenuItemProps) {
    super(props);
    this.state = {};
  }

  getProps = () => {
    const props: any = _.clone(this.props);
    if (props.icon) {
      // Both Material and Font Awesome glyphs size from the menu item's own
      // style.fontSize. When it's absent the size stays undefined so the icon
      // falls back to antd's menu icon slot sizing (like the legacy `<span
      // class="material-icons md-24">`) — a hardcoded size would render an
      // oversized glyph.
      props.icon = (
        <Icon
          iconName={props.icon}
          iconLibrary={props.iconLibrary}
          iconType={props.iconType}
          style={{ fontSize: props.style?.fontSize }}
        />
      );
    }
    if (props.iconLibrary) {
      delete props.iconLibrary;
    }
    if (props.iconType) {
      delete props.iconType;
    }
    if (props.label) {
      props.children = props.label;
    }
    if (props.link) {
      props.children = (
        <a href={props.link} target="_self">
          {props.label}
        </a>
      );
      delete props.label;
    }
    props.key = props.key ?? props.id ?? Guid.create().toString();

    // KOA-13032: At design time the canvas wraps every child in an
    // `internalComponentWrapper` <div> that is opaque to rc-menu's `parseChildren`,
    // so nested MenuItems never get an eventKey injected and render with
    // `data-menu-id="...-undefined"`. rc-menu keys selection and the inline-indent
    // level off eventKey, so nested items lose their indentation and independent
    // identity. Assign a stable, unique eventKey (the kuikaid) explicitly. Runtime
    // has no wrapper, so it is left untouched.
    if (window.kuika?.isDesignTime && props.kuikaid) {
      props.eventKey = props.kuikaid;
      props.key = props.kuikaid;
    }

    return props;
  };

  render(): ReactNode {
    return <Menu.Item {...this.getProps()}>{this.getProps().children}</Menu.Item>;
  }
}

const menuItem = withCommonEvents(MenuItem);
export { menuItem as MenuItem };
